import React, { useEffect, useState } from "react";
import TableContainer from "../../components/table/table-container";
import Button from "../../components/buttons/button";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/pagination/pagination";
import search from "../../assets/icons/searchIcon.svg";
import { useDispatch } from "react-redux";
import { errorToast } from "../../components/notifications/toast";
import { formatDate, statusColors } from "../../components/helper";
import Loader from "../../components/loaders/dot-loader";
import { listOrderAction } from "../../redux/actions/orderActio";

const Orders = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [debouncedValue, setDebouncedValue] = useState("");
    const [orders, setOrders] = useState([]);
    const [paginationData, setPaginationData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleEdit = (id) => {
        navigate(`/orders/edit/${id}`);
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(searchValue);
            setCurrentPage(1)
        }, 300);

        return () => {
            clearTimeout(handler);
        };
    }, [searchValue]);

    useEffect(() => {
        fetchorders()
    }, [currentPage, debouncedValue])

    const fetchorders = () => {
        setLoading(true)
        dispatch(listOrderAction({ page: currentPage, search: debouncedValue, page_size: 13 }, onSuccess, onError))
    }


    const onSuccess = (data) => {
        setOrders(data.data.data.orders);
        setPaginationData(data.data.data.pagination)
        setLoading(false)

    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
        setLoading(false)
    }


    return (
        <TableContainer>
            <div className="flex flex-col sm:flex-row justify-between px-2 pb-2 w-full">
                <div className="w-full sm:w-auto">
                    {/* Bread crumb data */}
                    <div
                        style={{ height: "2.5rem" }}
                        className={`input_border flex items-center rounded-md w-full sm:w-auto mx-1 md:w-80`}
                    >
                        <span className="px-2">
                            <img width={"16px"} src={search} alt="search icon" />
                        </span>
                        <input
                            placeholder={`Search here`}
                            className="table_search_input w-full rounded-md fs_12 placeholder:text-fs_12"
                            type="text"
                            value={searchValue}
                            onChange={(e) => {
                                setSearchValue(e?.target?.value);
                            }}
                        />
                        <span className='fs_14 mx-3 cursor-pointer text-primary' onClick={() => setSearchValue('')} >Clear</span>
                    </div>
                </div>

                <div className="w-full sm:w-auto mt-2 sm:mt-0">
                    <Button onClick={() => navigate('/orders/create')} variant="primary" size="md" className="w-full sm:w-auto">
                        Create Order
                    </Button>
                </div>
            </div>
            <div className="relative">
                <div className="overflow-auto border border-gray-300 rounded-md" style={{ height: '45rem' }}>
                    <table className="w-full border-collapse">
                        <thead>
                            <tr className="bg-gray-100 sticky top-0">
                                <th className="p-2 border border-gray-200 font-medium text-left">#</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Code</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Store Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Customer Name</th>
                                <th className="p-2 border border-gray-200 font-medium text-left">Customer Mobile</th>
                                <th className="p-2 border border-gray-200 font-medium ">Total Price</th>
                                <th className="p-2 border border-gray-200 font-medium ">Created By</th>
                                <th className="p-2 border border-gray-200 font-medium ">Status</th>
                                <th className="p-2 border border-gray-200 font-medium ">Ordered Date</th>
                                <th className="p-2 border border-gray-200 font-medium text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <Loader />
                                    </td>
                                </tr>
                            ) : orders.length > 0 ? orders.map((order, index) => (
                                <tr key={order.id} className="hover:bg-gray-50">
                                    <td className="p-3 border border-gray-200">{(currentPage - 1) * paginationData?.pageSize + (index + 1)}</td>
                                    <td className="p-3 border border-gray-200 text-left">{order?.code}</td>
                                    <td className="p-3 border border-gray-200 text-left">{order?.store?.name}</td>
                                    <td className="p-3 border border-gray-200 text-left">{order?.store?.customer_name}</td>
                                    <td className="p-3 border border-gray-200 text-left">{order?.store?.customer_mobile}</td>
                                    <td className="p-3 border border-gray-200 ">{parseFloat(order?.total).toFixed(2)}</td>
                                    <td className="p-3 border border-gray-200 ">{order?.createdBy ? order?.createdBy?.name : order?.admin?.name}</td>
                                    <td className="p-3 border border-gray-200" style={{ color: statusColors.find(item => item.status === order?.status).color }}> {order?.status} </td>
                                    <td className="p-3 border border-gray-200 ">{formatDate(order?.createdAt)}</td>
                                    <td className="p-3 border border-gray-200 text-center">
                                        <button
                                            onClick={() => navigate(`/orders/view/${order?.id}`, { state: { is_view: true } })}
                                            className="text-blue-500 hover:underline"
                                        >
                                            View
                                        </button>

                                        <button
                                            onClick={() => handleEdit(order?.id)}
                                            className="text-primary hover:underline mx-2"
                                            style={{ color: "#1E40AF" }}
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                            )) :
                                <tr>
                                    <td colSpan="10" style={{ height: '35rem' }}>
                                        <span className="text-gray-400 font-extralight"> No Orders Found</span>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>

                </div>
            </div>

            <div className="flex justify-end mt-2 bottom-0 right-0">
                <Pagination
                    totalPages={paginationData?.totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                />
            </div>
        </TableContainer >
    );
};

export default Orders;
